module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/.pnpm/echo-loader@0.0.1/node_modules/echo-loader/echo-loader.js!builtin:swc-loader??ruleSet[1].rules[1].use[1]!./home.jsx"));
	}, "home");
}